import { render, staticRenderFns } from "./LeadsReports.vue?vue&type=template&id=1ad2a806&scoped=true"
import script from "./LeadsReports.vue?vue&type=script&lang=js"
export * from "./LeadsReports.vue?vue&type=script&lang=js"
import style0 from "./LeadsReports.vue?vue&type=style&index=0&id=1ad2a806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad2a806",
  null
  
)

export default component.exports